import { render, staticRenderFns } from "./GeneradorPantalla.vue?vue&type=template&id=3f5527c1&scoped=true"
import script from "./GeneradorPantalla.vue?vue&type=script&lang=js"
export * from "./GeneradorPantalla.vue?vue&type=script&lang=js"
import style0 from "./GeneradorPantalla.vue?vue&type=style&index=0&id=3f5527c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5527c1",
  null
  
)

export default component.exports